import { render, staticRenderFns } from "./DraggableMixin.js.vue?vue&type=template&id=a4582128&"
import script from "./DraggableMixin.js.vue?vue&type=script&lang=js&"
export * from "./DraggableMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports